import { useEffect } from 'react';
import { observable } from 'mobx';
import BaseStore from '@src/utils/store/base-store';
import { getHashParams, updateHashParams } from '@src/utils/query-string-util.js';
import { go } from '@src/utils/promise/index';
import { navList } from '@src/constants/const';
import AntdMessage from '@src/components/antd/message';
import $$tracker from '@src/tracker';

class NavbarStore extends BaseStore {
  constructor({ changeActiveCb, mainStore }) {
    super();
    this.mainStore = mainStore;
    // TODO: 这里需要调整，预下载、内测、公测阶段字段还未知

    // 是否预约 根据config接口获取到的phone来确定是否预约
    // this.isReservation = this.mainStore?.projectConfig?.phone;
    // /** 是否公测阶段 */
    // this.publicBeta = publicBeta;
    // /** 是否内测测试阶段 */
    // this.testBeta = !publicBeta;

    // 更新选中tab的回调
    this.changeActiveCb = changeActiveCb;
  }
  /** 当前页面索引 */
  anchor = getHashParams().anchor || 'home';
  @observable currentPage = navList.find(item => item.key === this.anchor) ? this.anchor : 'home';
  @observable show = false;
  @observable isMax = false;

  /** 展示菜单 */
  showMenu = show => {
    this.show = show;
  };
  /** 打开预约弹窗 */
  onReservation = () => {
    if (this.mainStore?.projectConfig?.phone) return;
    $$tracker.clickReservation('顶部通栏');
    this.mainStore?.openReservationModal();
  };
  onClickWebsite = () => {
    $$tracker.clickGuanwang();
    window.location.href = 'https://js4.seasungames.cn/index/index.html';
  };

  /** 点击游戏 LOGO 返回首页 */
  onClickLogo = () => {
    this.setActiveIndex(0);
  };

  /** 设置当前页面索引 */
  setActiveIndex = index => {
    this.currentPage = navList[index].key;
    updateHashParams({ anchor: this.currentPage });
    this.changeActiveCb(this.currentPage);
  };

  /** 处理hashchange事件，更新当前页面索引 */
  handleHashChange = () => {
    const newAnchor = getHashParams().anchor || 'home';
    const validAnchor = navList.find(item => item.key === newAnchor) ? newAnchor : 'home';
    if (validAnchor === this.currentPage) return;
    this.currentPage = validAnchor;
  };

  /** 退出 */
  onLogout = async () => {
    const [data, err] = await go(this.$ztService.logout());
    if (err) {
      AntdMessage.error(err.message || '退出失败！');
      return;
    }
    AntdMessage.success('退出成功！');
    this.mainStore.getConfig();
    // this.logout();
  };

  use() {
    useEffect(() => {
      window.addEventListener('hashchange', this.handleHashChange);
      return () => {
        window.removeEventListener('hashchange', this.handleHashChange);
      };
    }, []);
  }
}

export default NavbarStore;
